import {
  BookOpenIcon,
  BrainIcon,
  CalendarX2Icon,
  ClipboardCheckIcon,
  ClipboardListIcon,
  FileSearchIcon,
  FileTextIcon,
  GaugeIcon,
  LayersIcon,
  TrendingUpIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react'

export type IconName =
  | 'bookOpen'
  | 'brain'
  | 'calendarX'
  | 'clipboardCheck'
  | 'clipboardList'
  | 'fileSearch'
  | 'fileText'
  | 'gauge'
  | 'layers'
  | 'trendingUp'
  | 'users'

export const icons: Record<IconName, LucideIcon> = {
  bookOpen: BookOpenIcon,
  brain: BrainIcon,
  calendarX: CalendarX2Icon,
  clipboardCheck: ClipboardCheckIcon,
  clipboardList: ClipboardListIcon,
  fileSearch: FileSearchIcon,
  fileText: FileTextIcon,
  gauge: GaugeIcon,
  layers: LayersIcon,
  trendingUp: TrendingUpIcon,
  users: UsersIcon,
}
